// extracted by mini-css-extract-plugin
export default {"mainContainer":"printing_mainContainer__24Ao3","tableContainer":"printing_tableContainer__cWnwk"};